import channelConfiguration from '../constants/channelConfigurationData';
export const fetchChannelConfiguration = () => new Promise(resolve => {
  resolve(channelConfiguration);
});